import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { CustomerPipeModule } from '../shared/pipes/customer-pipe.module';
import { CustomerIdentificationModalComponent } from './customer-identification-modal.component';
import { CustomerIdentificationComponent } from './customer-identification.component';

@NgModule({
    declarations: [
        CustomerIdentificationComponent,
        CustomerIdentificationModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        CustomerPipeModule,
        InputMaskModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerIdentificationComponent,
        CustomerIdentificationModalComponent
    ]
})
export class CustomerIdentificationModule {
}
